export type TabBodyPositionState = 'left' | 'center' | 'right' | 'left-origin-center' | 'right-origin-center';
export type TabBodyOriginState = 'left' | 'right';
